export const useCasesCards = [
  {
    title: "Amazon Connect Launch",
    type: "Contact Centre",
    description:
      "Empowering AWS clients to rapidly transform contact centers with AI-driven omnichannel experiences for immediate customer impact.",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/amazon-connect-thumbnail-iris.png",
  },
  {
    title: "Amazon Connect Managed Service",
    type: "Contact Centre",
    description:
      "Drive long-term value and retention with proactive optimization, support, and an AI roadmap aligned to customer experience goals.",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/amazon-connect-managed-service-iris.png",
  },
  {
    title: "Intelligent IVR Design",
    type: "Contact Centre Modernisation",
    description:
      "Empower clients with conversational self-service and smart workflows—reducing manual effort and boosting customer satisfaction.",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/intelligent-ivr-design-thumbnail-iris.png",
  },
  {
    title: "Digital AI Concierge",
    type: "iCXeed",
    description:
      "Enable AWS clients with always-on GenAI chatbots and seamless automation to elevate service quality and efficiency.",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/digital-ai-concierge-thumbnail-iris.png",
  },
  {
    title: "CX Perspectives Reporting & Analytics",
    type: "Advanced Contact Centre Reporting & Analytics",
    description:
      "Equip client teams with actionable insights and AI dashboards to drive smarter decisions and optimise experiences.",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/cx-perspectives-thumbnail-iris.png",
  },
];
